import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IInputProps } from 'utils/types/common';

const InputField: React.FC<IInputProps> = ({
  register,
  errors,
  title,
  name,
  placeHolder,
  type = 'text',
  errText = 'error',
  opts,
  disabled = false,
}) => {
  const err = Object.keys(errors)
    .filter((item) => item === name)
    .toString();

  return (
    <InputWrapper className='relative'>
      <TextWrapper className={`${err && 'text-red'}`}>{title}</TextWrapper>
      <Input
        disabled={disabled}
        type={type}
        placeholder={placeHolder}
        min='0'
        className={`${err ? 'border-red' : ''}`}
        {...register(name, opts)}
      />
    </InputWrapper>
  );
};

export default InputField;

const InputWrapper = styled.div`
  position: relative;
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .text-red {
    color: ${theme.colors.redText};
  }
`;

const Input = styled.input`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${theme.colors.gray_7};
  width: 100%;
  height: 40px;

  &:disabled {
    background-color: #e1e1e1;
    cursor: not-allowed;
  }
`;

const TextWrapper = styled.p`
  color: ${theme.colors.dark_500};
  font-size: ${theme.fontSizes.sm};
  margin-bottom: 8px;
`;
